/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamHandshakeCanaryResponseVerdict } from './oralExamHandshakeCanaryResponseVerdict';
import type { OralExamHandshakeCanaryResponseClassifiedAt } from './oralExamHandshakeCanaryResponseClassifiedAt';

/**
 * Last handshake canary verdict from Cosmos. ``gates_start`` is true on all envs.
 */
export interface OralExamHandshakeCanaryResponse {
  verdict?: OralExamHandshakeCanaryResponseVerdict;
  classifiedAt?: OralExamHandshakeCanaryResponseClassifiedAt;
  stale?: boolean;
  failureStage: string;
  fixCommand: string;
  gatesStart?: boolean;
  probeInFlight?: boolean;
}
